/**
 *** Additional Library/Plugin JS scripts
 ***
 **/

/* Intiate selectbox library on respective selectbox ids */
(function ($) {
	var ids = "#share-class-select, #frequency-distribution-quarter-select";
	$("select" + ids).niceSelect();
})(jQuery);

/**
 * Scroll to target for jumping URLs with anchor
 */
(function ($) {
	$(window).on("load", function () {
		if (location.hash) {
			// Timeout for allowing all the elements to set before getting offset values
			setTimeout(function () {
				$.when(
					$("html, body").animate(
						{
							scrollTop:
								$("body").find(location.hash).offset().top -
								120,
						},
						50
					)
				).done(function () {
					return false;
				});
			}, 500);
		}
	});
})(jQuery);

/**
 * Show More, Show Less button functionality for Articles bottom Authors
 */
jQuery(document).ready(function ($) {
	// Event delegation for show more/less functionality
	$(".author_excerpt__more-button").on("click", function (e) {
		e.preventDefault();
		if ($(this).hasClass("expanded")) {
			$(this).siblings(".author_excerpt").removeClass("expanded_link");
			$(this).removeClass("expanded").addClass("collapsed");
		} else {
			$(this).siblings(".author_excerpt").addClass("expanded_link");
			$(this).removeClass("collapsed").addClass("expanded");
		}
	});
});

/**
 * Articles Subscribe popup show hide functionality.
 */
(function ($) {
	var window_width = $(window).width();

	if (window_width < 768) {
		setInterval(function () {
			$(".banner-type-popup").addClass("mobile_popup");
		}, 5000);
	} else {
		$(".banner-type-popup").removeClass("mobile_popup");
	}

	function banner_popup() {
		$(window).scroll(function () {
			var window_width = window.innerWidth;
			if ($(this).scrollTop() > 1400 && window_width > 767) {
				$(".banner-type-popup").addClass("show_popup");
				$(".banner-type-popup").removeClass("mobile_popup");
			} else {
				$(".banner-type-popup").removeClass("show_popup");
			}
		});
	}
	banner_popup();

	function order_divs() {
		var window_width = window.innerWidth;
		$(".articles-special-row").each(function () {
			var $row = $(this);

			if (window_width < 768) {
				setTimeout(function () {
					$row.find(".feature_img").insertBefore(
						$row.find(".author_wrapper")
					);
				}, 1000);
				$row.find(".not_article_insights")
					.children(".related_insights_wrap")
					.remove()
					.insertBefore($row.find(".related-products"));
				$row.find(".author_items.btm_authors")
					.remove()
					.insertBefore($row.find(".related_theme"));
				$row.find(".related_insights_wrap.related_insights_article")
					.remove()
					.insertBefore($row.find(".related-products"));
			}
			if (window_width > 767) {
				$row.find(".feature_img")
					.remove()
					.insertBefore($row.find(".insert_feature_img"));
				$row.find(".related_insights_wrap").insertBefore(
					$row.find(".insert_related_insight")
				);
				$row.find(".not_article_insights")
					.children(".related_insights_wrap")
					.remove()
					.insertBefore($row.find(".insert_related_insight"));
				$row.find(".author_items.btm_authors")
					.remove()
					.insertBefore($row.find(".insert_btm_authors"));
				$row.find(".related_insights_wrap.related_insights_article")
					.remove()
					.insertBefore(
						$row.find(".insert_sidebar_related_insights")
					);
				setTimeout(function () {
					$row.find(
						".wrap-article-big-left .insights_image"
					).insertAfter(
						$row.find(".wrap-article-big-left .big_insights_thumb")
					);
				}, 1000);
			}
		});
	}
	order_divs();

	$(window).resize(function () {
		order_divs();
		banner_popup();
		var window_width = $(window).width();
		if (window_width < 768) {
			$(".banner-type-popup").addClass("mobile_popup");
		} else {
			$(".banner-type-popup").removeClass("mobile_popup");
		}
	});

	// Load more insights
	function jh_loadmore_insights() {
		$("#jh_load_more_insights > a").click(function () {
			var $nextLink = $(".pagination-bottom .next.page-link").attr(
				"href"
			);
			if ($nextLink) {
				$.ajax({
					type: "GET",
					url: $nextLink,
					beforeSend: function () {
						$(
							"#ajax-archive.jh_ajax_archive_insights .loading-overlay"
						).show();
					},
					success: function (html) {
						var $html = $($.parseHTML(html))
							.find("#jh_load_insights_card")
							.html();
						var $pagination = $($.parseHTML(html))
							.find("#jh_insights_pagination")
							.html();
						var $loadMore = $($.parseHTML(html))
							.find("#jh_load_more_insights")
							.html();
						$("#jh_load_insights_card").append($html);
						$("#jh_insights_pagination").html($pagination);
						$("#jh_load_more_insights").html($loadMore);
						jh_loadmore_insights();
						$(
							"#ajax-archive.jh_ajax_archive_insights .loading-overlay"
						).hide();
					},
				});
			}
			return false;
		});
	}
	jh_loadmore_insights();
	setTimeout(function () {
		$(".wrapper_filter_categories button.btn.dropdown-toggle").click();
		$(".wrapper_filter_categories .dropdown-menu > .inner").click(
			function () {
				$(
					".wrapper_filter_categories button.btn.dropdown-toggle"
				).click();
			}
		);
	}, 1000);
})(jQuery);

(function ($) {
	$(window).on("load", function () {
		$("select").on("click", function () {
			if ($("select").hasClass("select-dropdown-opened")) {
				$("select").removeClass("select-dropdown-opened");
			} else {
				$(this).addClass("select-dropdown-opened");
				$(this).removeClass("select-dropdown-closed");
			}
		});

		$("select").on("focusout", function () {
			$(this).removeClass("select-dropdown-opened");
			$(this).addClass("select-dropdown-closed");
		});
	});
})(jQuery);
